<template>
  <div>
    <div
      class="teacher-list-row d-flex justify-content-start align-items-center flex-wrap mb-3"
    >
      <MembersTeacherList
        :teacher_id="teacher.teacher_id"
        :teacher_img="teacher.image"
        :teacher_name="teacher.fullname"
        :teacher_subject="teacher.subjects"
        v-for="(teacher, index) in teachers_list"
        :key="index"
      ></MembersTeacherList>

      <div
        class="avatar avatar-square add-member-teacher position-relative pointer hint--primary hint--rounded hint--bottom-right"
        aria-label="Add Teacher"
        style="top:-5px; overflow: unset"
        @click="$emit('toggleTeacher')"
      >
        <div class="avatar-text transparent_bg">
          <span
            class="icon-plus border_grey_dark font-17 font-weight-400"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MembersTeacherRow",

  props: {
    teachers_list: Array,
  },

  components: {
    MembersTeacherList: () =>
      import(
        /* webpackChunkName: "MembersTeacherList" */ "@/components/classComps/studentSideBar/MembersTeacherList"
      ),
  },
};
</script>

<style lang="scss">
.add-member-teacher {
  border: 1px dashed $border_grey;

  &:hover {
    span {
      color: $brand_accent !important;
    }
  }
}
</style>
